export const environment = {
  isProd:true,
  apiUrl: 'https://www.sheba.co.il',
  cmsBase: 'https://www.sheba.co.il',
  baseMedia: 'https://www.sheba.co.il/cms-media',
  clientUrl: 'https://www.sheba.co.il',
  soundCloudUrl:
    'https://w.soundcloud.com/player?url={{URL}}&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true',
  languageConfiguration: {
    defaultLanguageIsoCode: 'he',
    languageStorageUrl: ''
  },
  recaptcha: {
    siteKey: '6Ld9wBIsAAAAAM4E8xGOBIsw9tsIMJsDV8fZQpWJ'
  },
  googleTagManagerId: 'GTM-P5L9Q2N8',
  appointmentRequestUrl: 'https://www.sheba.co.il/general/services/booking-appointments-in-sheba#e267c2d9-231f-4ef9-a09c-31dc54e2b954',
  phonePrefixes: [
    '050',
    '051',
    '052',
    '053',
    '054',
    '055',
    '057',
    '058',
    '02',
    '03',
    '04',
    '08',
    '09',
    '072',
    '073',
    '074',
    '076',
    '077',
    '079'
  ],
  previewKey: 'Sheba-Preview',
  customLobbyContainerBreadcrumbs: {
    he: 'לובי רופאים',
    en: 'doctor lobby'
  },
  navigationPaths: {
    DOCTORS_LOBBY: '/lobbies-container/doctors-lobby/',
    HOME: '/'
  },
  elasticsearch: {
    indexes: {
      job: 'job_index',
      labTest: 'lab_test_index',
      internalDepartment: 'internal_department_index',
      doctor: 'doctor_index',
      contentPage: 'content_page_index',
      event: 'event_index',
      generalContent: 'general_content_index',
      phoneIndex: 'phone_index',
      internalDepartmentIndex: 'internal_department_index',
      doctorShebaIndex: 'doctor_sheba_index'
    },
    typeKeywordBoosts: [
      { name: 'לובי', boost: 10 },
      { name: 'לובי בית חולים', boost: 10 }
    ]
  },
  cookieConsentDialog:"https://www.sheba.co.il/general/guides/privacy-policy",
  // TEMPORARY: List of text to exclude from lobby filters - TODO: Remove this later
  lobbyFilterExcludeList: ['כללי','general','общий','عام'],
  oldSiteAr:"https://arabic.sheba.co.il",
  oldSiteRu:"https://ru.sheba.co.il"
};
